import * as Sentry from '@sentry/vue';
import { bootstrapApp } from './bootstrapApp';

// Web entry point - maintains current behavior
// Initialize the app with standard Sentry configuration
const app = bootstrapApp({
    Sentry,
    tracesSampleRate: 0.1
});

app.$mount('#app');
